import React from "react";
import {SortableContainer} from "react-sortable-hoc";

const SortableList = SortableContainer(({children}) => {
    return (
        <div className={'sortable-container'}>
            {children}
        </div>
    );
});

export default SortableList;
